$(document).ready(function(){
  
        $('.xo-footer-nav__title').click(function(){  
            if($(window).width() < 768){
                $(this).siblings('.xo-footer-nav__list_area').slideToggle();
             }
        }); 

        $(document).on('click', '.xo-menu-hamburger__link.item_with_banner', function () {
            if($(window).width() > 1139){ 
                const $clicked = $(this);
 
                const $nextModal = $clicked.next('xo-modal');
 
                $clicked.siblings('xo-modal').not($nextModal).removeAttr('xo-active').removeAttr('xo-animate-active').removeAttr('xo-ready').css({
                    'pointer-events': 'none',
                    'z-index': '-1',
                    'visibility': 'hidden',
                    'opacity': '0'
                    });;
                    $nextModal
                        .css({
                        'z-index': '1000',
                        'visibility': 'visible',
                        'opacity': '1',
                        'pointer-events': 'auto'
                        });
             
            }
        });

    $(document).on('click', '.shopify-product-form xo-cart-add button.xo-btn', function () {
        console.log('clicked'); 
        if ($('.compulsory_add_cart button').length > 0) {
            $('.compulsory_add_cart button').trigger('click');
        }
    });
     
    $(document).on('click', '.menu_step_1 .xo-menu-hamburger__button-close', function(){ 
        $('.menu_step_1 .menu_trigger_step_3').removeClass('submenuActive');
        $('.menu_step_1').removeClass('second_menu_active'); 
    });
    $(document).on('click','.has_grand_submenu',function(e){
      e.preventDefault(); 
      $(this).toggleClass('sub_item_oppen'); 
      let $trigger = $(this).attr('data-target-menu'); 
      $($trigger).slideToggle(); 
    });
    $(document).on('click', '.menu_step_1 .menu_trigger_step_3', function () {

      if ($(window).width() <= 1139) return;

      let $trigger = $(this);
      let target = $trigger.data('child-id'); 
      if ($trigger.hasClass('submenuActive')) {

        $trigger.removeClass('submenuActive');
        $('.menu_step_1').removeClass('second_menu_active');
        $(target).removeClass('active');

      } else { 
        $('.menu_trigger_step_3').removeClass('submenuActive');
        $('.child_item_area').removeClass('active'); 
        $trigger.addClass('submenuActive');
        $('.menu_step_1').addClass('second_menu_active');
        $(target).addClass('active');
      }
    });

});

function validateCartForCheckout() {
  const requiredItems = document.querySelectorAll(
    '.xo-cart-item.is_required_product'
  );
  const compulsoryItems = document.querySelectorAll(
    '.xo-cart-item.has_compulsory_product'
  );

  const requiredCount = requiredItems.length;
  const compulsoryCount = compulsoryItems.length;

  // 🔔 message handling
  toggleCartMessages(requiredCount, compulsoryCount);

  // ✅ none present
  if (requiredCount === 0 && compulsoryCount === 0) {
    enableCheckout();
    return;
  }

  // ❌ one-sided present
  if (requiredCount === 0 || compulsoryCount === 0) {
    disableCheckout();
    return;
  }

  // IDs
  const requiredIds = Array.from(requiredItems).map(
    item => item.dataset.p_id
  );

  let compulsoryIds = [];
  compulsoryItems.forEach(item => {
    const ids = item.dataset.compulsory_p_id;
    if (ids) compulsoryIds.push(...ids.split('|'));
  });

  const isValid = requiredIds.every(id =>
    compulsoryIds.includes(id)
  );

  isValid ? enableCheckout() : disableCheckout();
}

/* helpers */
function disableCheckout() {
  const btn = document.querySelector('[name="checkout"]');
  if (btn) {
    btn.disabled = true;
    btn.classList.add('disabled');
  }
}

function enableCheckout() {
  const btn = document.querySelector('[name="checkout"]');
  if (btn) {
    btn.disabled = false;
    btn.classList.remove('disabled');
  }
}

function toggleCartMessages(requiredCount, compulsoryCount) {
  const requiredMsgs = document.querySelectorAll('.cart-required-message');
  const compulsoryMsgs = document.querySelectorAll('.cart-compulsory-message');

  if (!requiredMsgs.length || !compulsoryMsgs.length) return;

  const show = (elements) =>
    elements.forEach(el => el.classList.remove('hide'));

  const hide = (elements) =>
    elements.forEach(el => el.classList.add('hide'));

  if (requiredCount > 0 && compulsoryCount === 0) {
    show(requiredMsgs);
    hide(compulsoryMsgs);
    return;
  }

  if (compulsoryCount > 0 && requiredCount === 0) {
    show(compulsoryMsgs);
    hide(requiredMsgs);
    return;
  }

  hide(requiredMsgs);
  hide(compulsoryMsgs);
}

document.addEventListener('DOMContentLoaded', validateCartForCheckout);
document.addEventListener('mouseover', e => {
  if (e.target.closest('[name="checkout"]')) {
    validateCartForCheckout();
  }
});



$(document).ready(function () {

  if ($('.roland-testimonial .owl-carousel').length) {

    $('.roland-testimonial .owl-carousel').owlCarousel({
      items: 1,
      loop: true,
      margin: 0,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: true,
      animateOut: 'fadeOut',
      smartSpeed: 600,
      nav: false,
      navText: ['&#8592;', '&#8594;'],
      dots: true,
      responsive: {
        0: { items: 1 },
        750: { items: 1 }
      }
    });

  }
  /*
  $(document).on('click', '.q_plus_item.max-added',function(){
    $('.product_limit_note').addClass('active'); 
  });*/


  $('.page-menu-list .page-menu-link').click(function(){
     $('.page-menu-list .page-menu-link').removeClass('active'); 
     $(this).addClass('active'); 
  });

}); 